import { compareNaturalStrings } from '~shared/utils/sort/compareNaturalStrings';

export const naturalLibraryName = (row1, row2, columnName) => {
  const rowOneColumn = row1.values[columnName];
  const rowTwoColumn = row2.values[columnName];

  if (typeof rowOneColumn === 'string' && typeof rowTwoColumn === 'string') {
    return compareNaturalStrings(rowOneColumn, rowTwoColumn);
  }

  return Number(rowOneColumn) > Number(rowTwoColumn) ? 1 : -1;
};
